module.exports = __webpack_public_path__ + "static/media/solution16.1df048a6.png";